import AjaxInvitationService from './ajax-invitation-service'

class ProvinceService extends AjaxInvitationService {

  getListById(country_id, code) {
    const url = `/by-invitation/provinces`
    const headers = this.getInvitationHeader(code)
    return this.makeGetRequest(url, {country_id}, headers)
  }

  create(data, code) {
    const headers = this.getInvitationHeader(code)
    return this.makePostRequest('/by-invitation/provinces', data, headers)
  }
}

const _instance = new ProvinceService()
export default _instance